import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";

/* ─── Inject styles once ─── */
(() => {
  if (document.getElementById("asf-styles")) return;
  const el = document.createElement("style");
  el.id = "asf-styles";
  el.textContent = `
 
    .asf-root {
      font-family:'DM Sans',sans-serif;
      background:#fff;
      border:1.5px solid #eef0f6;
      border-radius:16px;
      overflow:hidden;
    }

    /* ── Header ── */
    .asf-header {
      display:flex; align-items:center; justify-content:space-between;
      padding:1rem 1.35rem;
      border-bottom:1px solid #eef0f6;
      background:#fff;
    }
    .asf-header-left { display:flex; align-items:center; gap:0.7rem; }
    .asf-header-icon {
      width:36px; height:36px; border-radius:10px;
      background:linear-gradient(135deg,#a00030,#c2003a);
      display:flex; align-items:center; justify-content:center; flex-shrink:0;
    }
    .asf-title {
      font-family:'Playfair Display',serif;
      font-size:0.98rem; font-weight:700; color:#111827; margin:0;
    }
    .asf-add-q-btn {
      display:inline-flex; align-items:center; gap:0.35rem;
      background:#fff3f6; color:#a00030;
      border:1.5px solid #ffc8d8; border-radius:8px;
      padding:0.36rem 0.85rem;
      font-family:'DM Sans',sans-serif; font-size:0.77rem; font-weight:700;
      cursor:pointer; transition:all 0.18s; white-space:nowrap;
    }
    .asf-add-q-btn:hover {
      background:#a00030; color:#fff; border-color:#a00030;
      box-shadow:0 3px 10px rgba(160,0,48,.2);
    }

    /* ── Questions ── */
    .asf-questions { display:flex; flex-direction:column; }

    /* ── Empty state ── */
    .asf-empty {
      display:flex; flex-direction:column; align-items:center;
      padding:2.5rem 1rem; gap:0.65rem;
    }
    .asf-empty p { font-size:0.82rem; color:#9ca3af; margin:0; text-align:center; }

    /* ── Question block ── */
    .asf-q-block {
      border-bottom:1px solid #f0f1f6;
      padding:1.1rem 1.35rem;
      background:#fff; transition:background 0.15s;
    }
    .asf-q-block:last-child { border-bottom:none; }
    .asf-q-block:hover { background:#fafbfc; }

    /* Number badge + content */
    .asf-q-row { display:flex; align-items:flex-start; gap:0.8rem; }
    .asf-q-num {
      width:24px; height:24px; border-radius:99px; flex-shrink:0;
      background:#a00030; color:#fff;
      font-size:0.63rem; font-weight:800;
      display:flex; align-items:center; justify-content:center;
      margin-top:4px;
    }
    .asf-q-body { flex:1; display:flex; flex-direction:column; gap:0.6rem; min-width:0; }

    /* Question textarea */
    .asf-q-input {
      width:100%; min-height:46px; padding:0.62rem 0.85rem;
      border:1.5px solid #e8eaf0; border-radius:10px;
      background:#fff; resize:vertical;
      font-family:'DM Sans',sans-serif; font-size:0.84rem; color:#111827;
      outline:none; transition:border-color 0.18s, box-shadow 0.18s;
      line-height:1.6; box-sizing:border-box;
    }
    .asf-q-input:focus { border-color:#a00030; box-shadow:0 0 0 3px rgba(160,0,48,0.08); }
    .asf-q-input::placeholder { color:#c0c8d8; }

    /* Controls row */
    .asf-controls { display:flex; align-items:center; gap:0.65rem; flex-wrap:wrap; }

    /* Type select */
    .asf-type-select {
      flex:1; max-width:210px; height:38px;
      padding:0 2rem 0 0.85rem;
      border:1.5px solid #e8eaf0; border-radius:9px;
      background:#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
      color:#374151; font-family:'DM Sans',sans-serif;
      font-size:0.82rem; font-weight:500;
      outline:none; cursor:pointer; appearance:none;
      transition:border-color 0.18s, box-shadow 0.18s;
    }
    .asf-type-select:focus { border-color:#a00030; box-shadow:0 0 0 3px rgba(160,0,48,0.08); }

    /* Remove question button */
    .asf-remove-q {
      display:inline-flex; align-items:center; gap:0.28rem;
      background:#fff; color:#dc2626;
      border:1.5px solid #fca5a5; border-radius:8px;
      padding:0.28rem 0.72rem;
      font-family:'DM Sans',sans-serif; font-size:0.74rem; font-weight:600;
      cursor:pointer; transition:all 0.18s; margin-left:auto;
    }
    .asf-remove-q:hover { background:#dc2626; color:#fff; border-color:#dc2626; }

    /* Text placeholder textarea */
    .asf-placeholder-input {
      width:100%; min-height:40px; padding:0.58rem 0.85rem;
      border:1.5px solid #e8eaf0; border-radius:9px;
      background:#f9fafb; resize:none;
      font-family:'DM Sans',sans-serif; font-size:0.82rem; color:#374151;
      outline:none; transition:border-color 0.18s, box-shadow 0.18s;
      box-sizing:border-box;
    }
    .asf-placeholder-input:focus {
      border-color:#a00030;
      box-shadow:0 0 0 3px rgba(160,0,48,0.08);
      background:#fff;
    }
    .asf-placeholder-input::placeholder { color:#c0c8d8; }

    /* Options section */
    .asf-opts-label {
      font-size:0.67rem; font-weight:700; text-transform:uppercase;
      letter-spacing:0.6px; color:#9ca3af; margin:0 0 0.45rem; display:block;
    }
    .asf-opts-list { display:flex; flex-direction:column; gap:0.5rem; }

    .asf-opt-row { display:flex; align-items:center; gap:0.6rem; }
    .asf-opt-label {
      font-size:0.67rem; font-weight:700; color:#9ca3af;
      text-transform:uppercase; letter-spacing:0.5px;
      white-space:nowrap; min-width:52px;
    }
    .asf-opt-input {
      flex:1; height:38px; padding:0 0.82rem;
      border:1.5px solid #e8eaf0; border-radius:9px;
      background:#fff; font-family:'DM Sans',sans-serif;
      font-size:0.82rem; color:#111827; outline:none;
      transition:border-color 0.18s, box-shadow 0.18s;
      box-sizing:border-box;
    }
    .asf-opt-input:focus { border-color:#a00030; box-shadow:0 0 0 3px rgba(160,0,48,0.08); }
    .asf-opt-input::placeholder { color:#c0c8d8; }

    .asf-remove-opt {
      width:28px; height:28px; border-radius:7px; flex-shrink:0;
      background:#fff; border:1.5px solid #fca5a5; color:#dc2626;
      display:flex; align-items:center; justify-content:center;
      cursor:pointer; transition:all 0.18s;
    }
    .asf-remove-opt:hover { background:#dc2626; color:#fff; border-color:#dc2626; }

    /* Add option button */
    .asf-add-opt-btn {
      display:inline-flex; align-items:center; gap:0.3rem;
      background:transparent; color:#a00030; border:none;
      padding:0.3rem 0; margin-top:0.3rem;
      font-family:'DM Sans',sans-serif; font-size:0.77rem; font-weight:700;
      cursor:pointer; transition:color 0.15s;
    }
    .asf-add-opt-btn:hover { color:#7a0024; }

    @media(max-width:480px) {
      .asf-controls { flex-wrap:wrap; }
      .asf-type-select { max-width:100%; }
      .asf-remove-q { margin-left:0; }
    }
  `;
  document.head.appendChild(el);
})();

/* ─── Module-level vars (unchanged from original) ─── */
var ansListId = { answer: "", answerId: null };
var ansList = "";

class SelfAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: [],
      frPollAnswer: [],
      frSurveyAnswer: [],
      selectGroupName: "",
      pollQuestion: "",
      inputsQuestion: [1],
      surveyQuestionType: "",
      surveyQuestion: [],
      inputsSurveyAnswer: [],
      answers: [],
    };
    this.removeMoreQuestions = this.removeMoreQuestions.bind(this);
    this.removeSurveyAnswers = this.removeSurveyAnswers.bind(this);
  }

  componentDidMount() {
    if (this.props.editState && this.props.assessmentListUpdated) {
      const count = [];
      const final = this.props.assessmentListUpdated.map((items, index) => {
        count.push(index);
        return {
          answerType: items.answerType,
          answers:
            items.answerType === "select" ? items.answers || items.answer : [],
          answerLength:
            items.answerType === "select" ? items.answers || items.answer : [],
          question: items.question,
          textTypeAnswer:
            items.answerType === "text" ? items.answers || items.answer : "",
          answerIds: items.answerType === "select" ? items.answerIds : [],
          questionId: items.questionId,
          answerId: items.answerId,
        };
      });
      this.setState({
        inputsQuestion: count.length === 0 ? [1] : count,
        surveyQuestion: final,
      });
    }
  }

  /* ══════════════════════════════════════
     RENDER
  ══════════════════════════════════════ */
  render() {
    const { t } = this.props;

    return (
      <div className="asf-root">

        {/* ── Header ── */}
        <div className="asf-header">
          <div className="asf-header-left">
            <div className="asf-header-icon">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11l3 3L22 4"/>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
              </svg>
            </div>
            <h4 className="asf-title">{t("Add your questions and options")}</h4>
          </div>

          <button className="asf-add-q-btn" onClick={this.addMoreQuestions}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            {t("+ Add more questions")}
          </button>
        </div>

        {/* ── Questions list ── */}
        <div className="asf-questions">

          {/* Empty state */}
          {this.state.inputsQuestion.length === 0 && (
            <div className="asf-empty">
              <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#e0e3ea" strokeWidth="1.5">
                <path d="M9 11l3 3L22 4"/>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
              </svg>
              <p>No questions yet — click <strong>+ Add more questions</strong> to begin</p>
            </div>
          )}

          {this.state.inputsQuestion.length > 0 &&
            this.state.inputsQuestion.map((entry, indexQuestion) => (
              <div className="asf-q-block" key={indexQuestion}>
                <div className="asf-q-row">

                  {/* Number badge */}
                  <span className="asf-q-num">{indexQuestion + 1}</span>

                  <div className="asf-q-body">

                    {/* ── Question textarea ── */}
                    <textarea
                      className="asf-q-input"
                      id={indexQuestion}
                      key={indexQuestion}
                      type="text"
                      onChange={(e) => this.handleInputQuestion(e, indexQuestion, "name")}
                      required=""
                      name="pollQuestion"
                      value={
                        this.state.surveyQuestion &&
                        this.state.surveyQuestion[indexQuestion] &&
                        this.state.surveyQuestion[indexQuestion].question
                      }
                      placeholder={t("Ask your question")}
                    />

                    {/* ── Controls: type select + remove ── */}
                    <div className="asf-controls">
                      <select
                        className="asf-type-select"
                        name="surveyQuestionType"
                        id="surveyQuestionType"
                        value={
                          this.state.surveyQuestion &&
                          this.state.surveyQuestion[indexQuestion] &&
                          this.state.surveyQuestion[indexQuestion].answerType
                        }
                        onChange={(e) => this.handleInputQuestion(e, indexQuestion, "type")}
                      >
                        <option value="">{t("Select")}</option>
                        <option value="text">{t("Text Field Option")}</option>
                        <option value="select">{t("Select Type Option")}</option>
                      </select>

                      {this.state.inputsQuestion.length > 1 && (
                        <button
                          className="asf-remove-q"
                          onClick={() =>
                            this.removeMoreQuestions(
                              entry,
                              indexQuestion,
                              this.state.surveyQuestion[indexQuestion]?.questionId
                            )
                          }
                        >
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 6h18"/>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                          </svg>
                          Remove Question
                        </button>
                      )}
                    </div>

                    {/* ── Text type answer ── */}
                    {this.state.surveyQuestion &&
                      this.state.surveyQuestion[indexQuestion] &&
                      this.state.surveyQuestion[indexQuestion].answerType == "text" && (
                        <textarea
                          className="asf-placeholder-input"
                          type="text"
                          onChange={(e) => this.handleInputQuestion(e, indexQuestion, "textTypeAnswer")}
                          required=""
                          name="textTypeAnswer"
                          value={
                            this.state.surveyQuestion &&
                            this.state.surveyQuestion[indexQuestion] &&
                            this.state.surveyQuestion[indexQuestion].textTypeAnswer
                          }
                          placeholder={t("Add your placeholder text here")}
                        />
                      )}

                    {/* ── Select type — options ── */}
                    {this.state.surveyQuestion &&
                      this.state.surveyQuestion[indexQuestion] &&
                      this.state.surveyQuestion[indexQuestion].answerType === "select" && (
                        <>
                          <span className="asf-opts-label">Answer Options</span>
                          <div className="asf-opts-list">
                            {this.state.surveyQuestion.length > 0 &&
                              this.state.surveyQuestion[indexQuestion].answerLength &&
                              this.state.surveyQuestion[indexQuestion].answerLength.map((entry, index) => (
                                <div className="asf-opt-row" key={index}>
                                  <span className="asf-opt-label">Option {index + 1}</span>
                                  <input
                                    key={index}
                                    className="asf-opt-input"
                                    type="text"
                                    onChange={(e) =>
                                      this.handleInputAns(
                                        e,
                                        index,
                                        "answerList",
                                        indexQuestion,
                                        this.state.surveyQuestion
                                      )
                                    }
                                    required=""
                                    name="frPollAnswer"
                                    placeholder={t("Add your option")}
                                    value={
                                      this.state.surveyQuestion &&
                                      this.state.surveyQuestion[indexQuestion] &&
                                      this.state.surveyQuestion[indexQuestion].answers[index]
                                    }
                                  />
                                  <button
                                    className="asf-remove-opt"
                                    title="Remove option"
                                    onClick={() => this.removeSurveyAnswers(indexQuestion, index)}
                                  >
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                      <line x1="18" y1="6" x2="6" y2="18"/>
                                      <line x1="6" y1="6" x2="18" y2="18"/>
                                    </svg>
                                  </button>
                                </div>
                              ))}
                          </div>

                          <button
                            className="asf-add-opt-btn"
                            onClick={() => this.addSurveyAnswers(indexQuestion)}
                          >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                              <line x1="12" y1="5" x2="12" y2="19"/>
                              <line x1="5" y1="12" x2="19" y2="12"/>
                            </svg>
                            {t("+ Add more option")}
                          </button>
                        </>
                      )}

                  </div>
                </div>
              </div>
            ))}
        </div>

      </div>
    );
  }

  /* ══════════════════════════════════════
     ALL METHODS — IDENTICAL TO ORIGINAL
  ══════════════════════════════════════ */

  addSurveyAnswers = (questionIndex) => {
    this.setState((prevState) => {
      const updatedSurveyQuestions = [...prevState.surveyQuestion];
      const updatedAnswerLength = [
        ...updatedSurveyQuestions[questionIndex].answerLength,
      ];
      updatedAnswerLength.push(1);
      updatedSurveyQuestions[questionIndex] = {
        ...updatedSurveyQuestions[questionIndex],
        answerLength: updatedAnswerLength,
      };
      return { surveyQuestion: updatedSurveyQuestions };
    });
    ansListId = { answer: "", answerId: null };
    ansList = "";
  };

  async removeSurveyAnswers(indexQuestion, index) {
    ansList = "";
    ansListId = { answer: "", answerId: null };
    if (this.state.surveyQuestion[indexQuestion].answerLength) {
      var val = this.state.surveyQuestion[indexQuestion].answerLength;
      var ans = this.state.surveyQuestion[indexQuestion].answers;
      var ansId = this.state.surveyQuestion[indexQuestion].answerIds;
      val.splice(index, 1);
      ans.splice(index, 1);
      ansId.splice(index, 1);
      this.setState({});
      this.props.surveyQuestion(this.state.surveyQuestion);
    }
  }

  async removeMoreQuestions(record, index, questionId) {
    ansList = "";
    ansListId = { answer: "", answerId: null };
    var inpu = this.state.inputsQuestion;
    if (this.state.inputsQuestion.length > 1) {
      inpu.splice(index, 1);
      if (this.state.surveyQuestion[index]) {
        var val = this.state.surveyQuestion;
        val.splice(index, 1);
        this.setState({ surveyQuestion: val });
      }
      await this.setState({ inputsQuestion: inpu });
      this.props.surveyQuestion(val);
    }
    if (this.props.editState) {
      this.props.removedQuestionId(questionId);
    }
  }

  addMoreQuestions = (e) => {
    ansList = "";
    ansListId = { answer: "", answerId: null };
    var input = this.state.inputsQuestion;
    if (this.state.inputsQuestion.length === 0) {
      input.push(1);
      this.setState({ inputsQuestion: input });
    } else if (this.state.surveyQuestion.length !== 0) {
      if (
        this.state.surveyQuestion[this.state.inputsQuestion.length - 1] !==
        undefined
      ) {
        var addMoreEnable =
          this.state.surveyQuestion[this.state.inputsQuestion.length - 1]
            .answerType;
        if (
          this.state.surveyQuestion[this.state.inputsQuestion.length - 1]
            .question === ""
        ) {
          Swal.fire({ icon: "warning", text: "Please fill your question", timer: 3000 });
        } else if (addMoreEnable === undefined || addMoreEnable === "") {
          Swal.fire({ icon: "warning", text: "Please select your answer type", timer: 3000 });
        } else if (
          addMoreEnable === "text" &&
          this.state.surveyQuestion[this.state.inputsQuestion.length - 1]
            .textTypeAnswer === ""
        ) {
          Swal.fire({ icon: "warning", text: "Please Add your comments", timer: 3000 });
        } else if (
          addMoreEnable === "select" &&
          this.state.surveyQuestion[this.state.inputsQuestion?.length - 1]
            .answers.length === 0
        ) {
          Swal.fire({ icon: "warning", text: "Please Add your answer poll", timer: 3000 });
        } else {
          input.push(1);
          this.setState({ inputsQuestion: input });
        }
      } else {
        Swal.fire({ icon: "warning", text: "Please Add your questions", timer: 3000 });
      }
    } else {
      Swal.fire({ icon: "warning", text: "Please Add your Questions", timer: 3000 });
    }
  };

  handleInputQuestion = (event, index, type, indexQuestion) => {
    event.preventDefault();
    event.stopPropagation();
    var newAnswers = this.state.surveyQuestion;
    if (newAnswers[index]) {
      if (type == "name") {
        var obj = newAnswers[index];
        obj.question = event.target.value;
        newAnswers[index] = obj;
      } else if (type == "type") {
        var obj = newAnswers[index];
        obj.answerType = event.target.value;
        obj.answerLength = event.target.value === "select" ? [1] : [];
        obj.answers = [];
        obj.textTypeAnswer = "";
        newAnswers[index] = obj;
      } else if (type == "textTypeAnswer") {
        var obj = newAnswers[index];
        obj.textTypeAnswer = event.target.value;
        newAnswers[index] = obj;
      }
    } else {
      if (type == "name") {
        var obj = {
          question: event.target.value,
          answerType: "",
          textTypeAnswer: "",
          answers: [],
          answerLength: [],
          answerIds: [],
        };
        newAnswers[index] = obj;
      } else if (type == "type") {
        var obj = {
          question: "",
          answerType: event.target.value,
          textTypeAnswer: "",
          answers: [],
          answerLength: [],
          answerIds: [],
        };
        newAnswers[index] = obj;
      } else if (type == "textTypeAnswer") {
        var obj = {
          question: "",
          textTypeAnswer: event.target.value,
          answers: [],
          answerType: "",
          answerLength: [],
          answerIds: [],
        };
        newAnswers[index] = obj;
      }
    }
    this.setState({ surveyQuestion: newAnswers });
    this.props.surveyQuestion(newAnswers);
  };

  handleInputAns = (event, index, type, indexQuestion) => {
    var answerId =
      this.state.surveyQuestion[indexQuestion]?.answerIds[index]?.answerId;
    event.preventDefault();
    event.stopPropagation();
    var qList = this.state.surveyQuestion;
    var newAnswers = this.state.surveyQuestion[indexQuestion]?.answers;
    if (newAnswers && newAnswers[index]) {
      if (type == "answerList") {
        ansListId = {
          answer: event.target.value,
          answerId: answerId ? answerId : null,
        };
        ansList = event.target.value;
        var checkId = qList[indexQuestion].answerIds;
        var check = qList[indexQuestion].answers;
        if (event.target.value.length === 0) {
          qList[indexQuestion].answerIds[index] = {
            answer: "",
            answerId: answerId ? answerId : null,
          };
          qList[indexQuestion].answers[index] = " ";
        } else if (check[index]) {
          checkId[index] = ansListId;
          check[index] = ansList;
        } else {
          checkId.answerIds.push(ansListId);
          check.answers.push(ansList);
          ansListId = { answer: "", answerId: answerId ? answerId : null };
          ansList = "";
        }
      }
    } else {
      if (type === "answerList") {
        let obj = { answer: event.target.value, answerId: null };
        ansList = event.target.value;
        qList[indexQuestion].answers.push(ansList);
        qList[indexQuestion].answerIds.push(obj);
      }
    }
    this.setState({ surveyQuestion: qList });
    this.props.surveyQuestion(qList);
  };
}

export default withTranslation()(withRouter(SelfAssessment));